// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bho_a bic_h","Menu__offsetParent":"bho_b bic_bj","Menu__trigger--shadowed":"bho_c"};